import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 24 24', fill: 'none' },
        child: [
            {
                tag: 'rect',
                attr: { width: '24', height: '24', rx: '12', fill: '#F0FFFF' },
            },
            {
                tag: 'rect',
                attr: {
                    x: '5.69971',
                    y: '6.23401',
                    width: '12.6',
                    height: '11.232',
                    fill: '#CFEFFF',
                },
            },
            {
                tag: 'rect',
                attr: {
                    x: '5.69971',
                    y: '6.23401',
                    width: '12.6',
                    height: '0.936',
                    fill: '#5DC1F2',
                },
            },
            {
                tag: 'mask',
                attr: {
                    id: 'icon-aiqycboi3',
                    masktype: 'alpha',
                    maskUnits: 'userSpaceOnUse',
                    x: '4',
                    y: '9',
                    width: '16',
                    height: '3',
                },
                child: [
                    {
                        tag: 'path',
                        attr: {
                            d: 'M5.08105 9.97803H18.8201L19.1998 10.4314V11.5283H4.7998V10.4314L5.08105 9.97803Z',
                            fill: '#C4C4C4',
                        },
                    },
                ],
            },
            {
                tag: 'g',
                attr: { mask: 'url(#icon-aiqycboi3)' },
                child: [
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '7.68252',
                            cy: '10.3583',
                            rx: '0.857813',
                            ry: '0.9945',
                            fill: '#D8DEE2',
                        },
                    },
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '11.8309',
                            cy: '10.3583',
                            rx: '0.871875',
                            ry: '0.9945',
                            fill: '#D8DEE2',
                        },
                    },
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '16.0499',
                            cy: '10.3875',
                            rx: '0.9',
                            ry: '1.02375',
                            fill: '#D8DEE2',
                        },
                    },
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '5.82637',
                            cy: '10.2267',
                            rx: '1.02656',
                            ry: '1.06763',
                            fill: '#45A9E3',
                        },
                    },
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '9.74971',
                            cy: '10.212',
                            rx: '1.2375',
                            ry: '1.287',
                            fill: '#45A9E3',
                        },
                    },
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '13.9123',
                            cy: '10.2267',
                            rx: '1.2375',
                            ry: '1.30163',
                            fill: '#45A9E3',
                        },
                    },
                    {
                        tag: 'ellipse',
                        attr: {
                            cx: '18.0609',
                            cy: '10.212',
                            rx: '1.13906',
                            ry: '1.17',
                            fill: '#45A9E3',
                        },
                    },
                ],
            },
            {
                tag: 'rect',
                attr: {
                    x: '7.0498',
                    y: '12.3181',
                    width: '5.4',
                    height: '2.83725',
                    fill: '#5DC1F2',
                },
            },
            {
                tag: 'rect',
                attr: {
                    x: '13.7715',
                    y: '12.3181',
                    width: '3.17813',
                    height: '5.148',
                    fill: '#5DC1F2',
                },
            },
            {
                tag: 'mask',
                attr: {
                    id: 'icon-touvb9wfo',
                    masktype: 'alpha',
                    maskUnits: 'userSpaceOnUse',
                    x: '4',
                    y: '7',
                    width: '16',
                    height: '4',
                },
                child: [
                    {
                        tag: 'path',
                        attr: {
                            d: 'M6.13574 7.63806H17.892L19.1998 10.4461H4.7998L6.13574 7.63806Z',
                            fill: '#C4C4C4',
                        },
                    },
                ],
            },
            {
                tag: 'g',
                attr: { mask: 'url(#icon-touvb9wfo)' },
                child: [
                    {
                        tag: 'path',
                        attr: {
                            d: 'M6.86699 11.0164L8.00605 7.4918L6.02324 7.40405L4.58887 10.6508L6.86699 11.0164Z',
                            fill: '#79CBF3',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M17.0063 10.5777L15.9938 7.47722L14.3906 7.19934L14.9672 10.5777H17.0063Z',
                            fill: '#EFF1F2',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M8.70928 11.2358L9.48271 7.44793L7.80928 7.33093L6.78271 10.6216L8.70928 11.2358Z',
                            fill: '#EFF1F2',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M11.0578 11.0457L11.2406 7.43334L9.32813 7.19934L8.48438 10.6362L11.0578 11.0457Z',
                            fill: '#79CBF3',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M12.9278 10.8117L12.731 7.41872L11.156 7.19934L10.9731 10.6801L12.9278 10.8117Z',
                            fill: '#EFF1F2',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M15.1779 10.5631L14.4607 7.41868L12.6748 7.33093V10.5631H15.1779Z',
                            fill: '#79CBF3',
                        },
                    },
                    {
                        tag: 'path',
                        attr: {
                            d: 'M17.0203 10.68L15.9375 7.31628L18.6094 7.68191L19.1859 9.70016L19.3547 10.5338L17.0203 10.68Z',
                            fill: '#79CBF3',
                        },
                    },
                ],
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: false })) })));
};
const CircleShowroomColored = React.forwardRef(IconComponent);
CircleShowroomColored.displayName = 'CircleShowroomColored';

export { CircleShowroomColored };
